import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { MatFormField } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatAnchor } from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PacienteService } from '../../core/services/pacientes.service';
import { Paciente } from '../pacientes/pacientes';
import { ResumenEstudiosDialog } from './resumen-estudios-dialog/resumen-estudios-dialog';
import { ResumenRecetaDialog } from './resumen-receta-dialog/resumen-receta-dialog';
// import { ResumenEstudiosDialog } from './resumen-estudios-dialog/resumen-estudios-dialog';
// import { ResumenRecetaDialog } from './resumen-receta-dialog/resumen-receta-dialog';

@Component({
  selector: 'app-estudios',
  standalone: true,
  imports: [
    FormsModule,
    MatIcon,
    MatFormField,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatAnchor,
    MatButtonModule,
    MatTableModule,
    MatTooltipModule,
  ],
  templateUrl: './estudios.html',
  styleUrl: './estudios.scss',
})
export class Estudios implements OnInit {
  columnas: string[] = ['paciente', 'estudios', 'receta'];

  pacientes = new MatTableDataSource<Paciente>();

  busqueda: string = '';

  constructor(
    private dialog: MatDialog,
    private pacienteService: PacienteService,
  ) {}

  limpiarBusqueda(input?: HTMLInputElement): void {
    this.busqueda = '';
    this.filtrarPacientes();
    input?.focus(); // deja el cursor listo para escribir otro nombre
  }

  ngOnInit(): void {
    this.pacientes.filterPredicate = (paciente: Paciente, filtro: string) => {
      const texto = filtro.toLowerCase().trim();

      const nombreCompleto = `
        ${paciente.nombre ?? ''}
        ${paciente.apellido ?? ''}
        ${paciente.segundoApellido ?? ''}
      `.toLowerCase();

      const telefono = paciente.telefono?.toLowerCase() ?? '';
      const correo = paciente.correo?.toLowerCase() ?? '';

      return nombreCompleto.includes(texto) || telefono.includes(texto) || correo.includes(texto);
    };

    this.cargarPacientes();
  }

  filtrarPacientes(): void {
    this.pacientes.filter = this.busqueda.trim().toLowerCase();
  }

  cargarPacientes(): void {
    this.pacienteService.obtenerPacientes().subscribe({
      next: (respuesta) => {
        this.pacientes.data = respuesta.sort((a, b) => {
          const nombreA = `${a.nombre ?? ''} ${a.apellido ?? ''} ${a.segundoApellido ?? ''}`.trim();

          const nombreB = `${b.nombre ?? ''} ${b.apellido ?? ''} ${b.segundoApellido ?? ''}`.trim();

          return nombreA.localeCompare(nombreB, 'es', {
            sensitivity: 'base',
          });
        });
      },

      error: (error) => {
        // console.error('Error al cargar pacientes:', error);
      },
    });
  }

  abrirResumenEstudios(paciente: Paciente): void {
    this.dialog.open(ResumenEstudiosDialog, {
      width: '700px',
      maxWidth: '95vw',
      height: '80vh',
      data: paciente,
    });
  }

  abrirResumenReceta(paciente: Paciente): void {
    this.dialog.open(ResumenRecetaDialog, {
      width: '700px',
      maxWidth: '95vw',
      height: '80vh',
      data: paciente,
    });
  }
}
